import { NavLink } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getEquipmentAlertsDiagnosisByQuery } from "components/axios/equipmentAlertsAxios";
import MainCard from "components/MainCard";
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import PageInfo from "components/PageInfo";
import { useEnumApi } from "contexts/EnumApiContext";
import { fromServerFormat } from "components/date_picker/dateUtils";
import { makeFaultsMessage2 } from "data/data";
import CommonLargeExcelDownload from "components/CommonLargeExcelDownload";

const EquipmentAlertListCard = ({equipmentId, equipmentNo, type="list"}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    let [pageInfo, setPageInfo] = useState({});
    let [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    // const [isLoading, setIsLoading] = useState(false);
    //{t('menu.cmms.report-dataroom.status-report.equipment-status')}
    const excelTitle = t('menu.cmms.equipment-alert-history-tracking');
    const excelHeaders = ['No.',t('message.common.subtitle.status'),t('message.common.subtitle.dateAt'),t('message.common.subtitle.alertType'),t('message.common.subtitle.alertCategory'),t('message.common.subtitle.description')];
    const [excelParam, setExcelParam] = useState([]);
    // const fileName = excelTitle+"_"+Date.now();
    // const [excelDatas, setExcelDatas] = useState([]);

    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
        // setIsLoading(false);
    }

    const [equipmentAlerts, setEquipmentAlerts] = useState();
    
    useEffect(()=>{
        if (equipmentId) {
            getEquipmentAlertList(equipmentId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPage, equipmentId]);

    const getEquipmentAlertList = (equipmentId) => {
        if (equipmentId) {
            isNaN(currentPage) && setCurrentPage(0);
            isNaN(pageSize) && setPageSize(10);

            let param = {
                sort : "latestAlertedAt,desc",
                page : currentPage,
                size : pageSize,
                "equipment.id" : equipmentId
            };

            const { page, size, ...rest } = param;
            setExcelParam(rest);

            getEquipmentAlertsDiagnosisByQuery(param).then((data)=>{
                if (data !== null) {
                    if(data.page) {
                        setPageInfo(data.page);
                    } else {
                        setCurrentPage(0);
                        pageInfo = {
                            size : pageInfo.size,
                            totalElements : 0,
                            totalPages : 0,
                            number : 0
                        }
                        setPageInfo(pageInfo);
                    }
                    
                    if (data && data._embedded) {
                        setEquipmentAlerts(data._embedded.equipmentAlerts);
                        return data.page.totalElements;
                    } else {
                        setEquipmentAlerts([]);
                        return 0;
                    }
                }
                
            })
            
        } else {
            setEquipmentAlerts([]);
            // setExcelDatas([]);
        }
    }
    
    const dataMappingRules = (column, index, totalElements, startIndex) => {
        const rowNumber = totalElements - (startIndex + index);
        
        let alertDtl = (column.alertDtl ?? '');
        alertDtl += makeFaultsMessage2(column, getEnumValueByEnumNameAndCode, "\n");

        let rowData = [
            rowNumber,
            (column.status && column.status == 'D' ? (getEnumValueByEnumNameAndCode("EquipmentAlertStatus", column.status)?.[0]?.title)
                : column.status == 'M' && column.fllwActionType ? (getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)?.[0]?.title): ''),
            ((column.latestAlertedAt && fromServerFormat(column.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})) || ''),
            ((column.alertType && getEnumValueByEnumNameAndCode("AlertType", column.alertType)?.[0]?.title) || ''),
            ((column.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)?.[0]?.title) || ''),
            ((alertDtl) || '')
        ];

        return rowData;
    };

    // if (isLoading) {
        return (
            <div className={`${type === 'list'?'alert_phrase' : 'cn_dash_tabbox'}`} style={{marginTop: `${type === 'list'?"20px":"0px"}`}}>
                <MainCard className="center_table" content={false}>
                    {type === 'list' &&
                    <div className='more' style={{paddingBottom: "10px"}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                            <Chip label={t('menu.cmms.equipment-alert-history-tracking')} />
                        </div>
                        
                        <div style={{display:"flex",alignItems:"center"}}>
                            <CommonLargeExcelDownload 
                                title={excelTitle}
                                excelHeader={excelHeaders}
                                excelParam={excelParam}
                                fetchApiFn={getEquipmentAlertsDiagnosisByQuery} // 👈 액시오스 함수 매핑
                                mappingFn={dataMappingRules}               // 👈 파싱 룰 데이터 매핑
                                apiKey="equipmentAlerts"                          // 👈 JSON 응답 타겟 키 지정
                                pageSize={5000}                                   // 백엔드 제한 수치 수용
                                totalCount={pageInfo.totalElements}
                            />
                            
                            &nbsp;&nbsp;<NavLink href={`/equipment-alert-history-tracking?searchField=equipmentNo&searchKeyword=${equipmentNo}`} className='more_btn'>{t('message.common.btn.more')} +</NavLink>
                        </div>
                    </div>
                    }
                    <TableContainer>
                    <Table sx={{ minWidth: 500 }} aria-label="simple table" className="base_link">
                        <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{width:"90px"}}>{t('message.common.subtitle.status')}</TableCell>
                            <TableCell style={{width:"150px"}}>{t('message.common.subtitle.dateAt')}</TableCell>
                            <TableCell align="center" style={{width:"80px"}}>{t('message.common.subtitle.alertType')}</TableCell>
                            <TableCell align="center" style={{width:"100px"}}>{t('message.common.subtitle.alertCategory')}</TableCell>
                            <TableCell align="center">{t('message.common.subtitle.description')}</TableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {equipmentAlerts && equipmentAlerts.map((alert, i) => {
                            let linkUrl = "/equipment-alert-history-tracking/"+alert.id+"?searchField=equipmentNo&searchKeyword="+equipmentNo;
                            let statusClassName = '';
                            let fllwActionStatusName = '';
                            if (alert.status) {
                                if (alert.status === 'D') {
                                    statusClassName = 'condition1';
                                } else if (alert.status === 'F') {
                                    statusClassName = 'condition2';
                                } else if (alert.status === 'M') {
                                    if (alert.fllwActionType) {
                                        if (alert.fllwActionType === 'O1_WAIT') {
                                            statusClassName = 'condition1';
                                        } else if (alert.fllwActionType === 'O2_OBSERVE') {
                                            statusClassName = 'condition2';
                                            if (alert.atentObserv?.status && alert.atentObserv?.status === 'R') {
                                                statusClassName = 'condition4';
                                            }
                                        } else if (alert.fllwActionType === 'O3_MNT') {
                                            statusClassName = 'condition5';
                                            if (alert.mntTask?.status && alert.mntTask?.status === 'O1_R') {
                                                statusClassName = 'condition1';
                                            } else if (alert.mntTask?.status && alert.mntTask?.status === 'O2_P') {
                                                statusClassName = 'condition2';
                                            } else if (alert.mntTask?.status && alert.mntTask?.status === 'O3_C') {
                                                statusClassName = 'condition5';
                                            } else if (alert.mntTask?.status && alert.mntTask?.status === 'O4_V') {
                                                statusClassName = 'condition6';
                                            }
                                        } else if (alert.fllwActionType === 'O4_NORMAL') {
                                            statusClassName = 'condition6';
                                        }
                                    }
                                }
                            }

                            let alertDtl = (alert.alertDtl ?? '');
                            alertDtl += makeFaultsMessage2(alert, getEnumValueByEnumNameAndCode);
                            // if (alert.alertType === 'IOT' && alertDtl.indexOf(t('message.common.text.iot.diagnosis')) !== -1) {
                            // if (alert.equipmentPartFaultCodes && alert.equipmentPartFaultCodes.length > 0) {
                            //     alertDtl += (alertDtl && "<br/>");
                            //     alert.equipmentPartFaultCodes.map(function(codes, idx) {
                            //         alertDtl += codes.equipmentPart?.componentLocation?.name+' - '+codes.equipmentPart?.masterEquipmentPart?.name+' : ';
                            //         alertDtl += codes.diagnosisCode?.subCategoryNm+'('+codes.diagnosisCode?.categoryNm+')<br />';
                            //     })
                            // }
                            // }
                            return (
                            <TableRow hover key={i} style={{verticalAlign:"top"}}>
                                <TableCell component="th" scope="row" style={{whiteSpace:"pre-line"}}>
                                    <NavLink href={linkUrl}><div className={statusClassName}>
                                    {(alert.status && alert.status === 'D' || alert.status && alert.status === 'F') && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", alert.status)?.[0]?.title}
                                    {alert.status && alert.status === 'M' && alert.fllwActionType &&
                                    getEnumValueByEnumNameAndCode("FollowActionType", alert.fllwActionType)?.[0]?.title}
                                    {fllwActionStatusName ? `\n${fllwActionStatusName}` : ''}</div></NavLink>
                                </TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.latestAlertedAt && fromServerFormat(alert.latestAlertedAt, {format : t('message.common.text.date.format.datetime')})}</NavLink></TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.alertType && getEnumValueByEnumNameAndCode("AlertType", alert.alertType)?.[0]?.title}</NavLink></TableCell>
                                <TableCell align="center"><NavLink href={linkUrl}>{alert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", alert.alertCategory)?.[0]?.title}</NavLink></TableCell>
                                <TableCell style={{whiteSpace:"pre-line",textAlign:"left"}}><NavLink href={linkUrl} dangerouslySetInnerHTML={ {__html: alertDtl } }></NavLink></TableCell>
                            </TableRow>
                        )
                        })}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
                </MainCard>
            </div>
        )
    // }
}

export default EquipmentAlertListCard;